export default {"src":"/_next/static/media/StampLight.87935876.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};